import { useEffect, useRef, forwardRef } from "react";
import {
	MOUSE,
	Vector2,
	Vector3,
	Vector4,
	Quaternion,
	Matrix4,
	Spherical,
	Box3,
	Sphere,
	Raycaster,
	MathUtils,
} from "three";
import { extend, useFrame, useThree } from "@react-three/fiber";
import CameraControlsDefault from "camera-controls";
const subsetOfTHREE = {
	MOUSE: MOUSE,
	Vector2: Vector2,
	Vector3: Vector3,
	Vector4: Vector4,
	Quaternion: Quaternion,
	Matrix4: Matrix4,
	Spherical: Spherical,
	Box3: Box3,
	Sphere: Sphere,
	Raycaster: Raycaster,
	MathUtils: {
		DEG2RAD: MathUtils.DEG2RAD,
		clamp: MathUtils.clamp,
	},
};
CameraControlsDefault.install({ THREE: subsetOfTHREE });
extend({ CameraControlsDefault });
export const CameraControls = forwardRef((_, ref) => {
	const cameraControls = useRef(null);
	const { camera, gl } = useThree();
	useFrame((_, delta) => {
		cameraControls.current?.update(delta);
	});
	useEffect(() => {
		gl.domElement.addEventListener("wheel", onDocumentMouseWheel);
		return () => {
			gl.domElement.removeEventListener("wheel", onDocumentMouseWheel);
			cameraControls.current?.dispose();
		};	}, []);

	const onDocumentMouseWheel = (event) => {
		const fov = camera.fov + event.deltaY * 0.05;
		camera.fov = MathUtils.clamp(fov, 30, 85);
		camera.updateProjectionMatrix();
	};
	return (
		<>
			<cameraControlsDefault
				ref={mergeRefs(cameraControls, ref)}
				args={[camera, gl.domElement]}
				dampingFactor={0.1}
				draggingDampingFactor={0.1}
				minZoom={0.5}
				maxZoom={3}
				azimuthRotateSpeed={-0.5}
				polarRotateSpeed={-0.5}
				maxDistance={1}
				mouseButtons={{ left: 1 }}
			/>
		</>
	);
});
function mergeRefs(...refs) {
	return (instance) => {
		for (const ref of refs) {
			if (typeof ref === "function") {
				ref(instance);
			} else if (ref) {
				ref.current = instance;
			}
		}
	};
}
